export default __webpack_public_path__ + "4b272b7a5142846bdc732ee16a8647df.png";